import { render, staticRenderFns } from "./academic-programs.vue?vue&type=template&id=298625ff&"
import script from "./academic-programs.vue?vue&type=script&lang=js&"
export * from "./academic-programs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports